/* eslint-disable max-classes-per-file */

import { Cloudinary } from 'cloudinary-core';
import _, { sortBy } from 'lodash';
import { createContext, useContext, useEffect, useState } from 'react';

import featuresConfig from './featuresConfig';
import { useLocaleCode, getFeatureTranslations } from './useFeatureTranslations';
// eslint-disable-next-line camelcase
import cms_api from '../../../cms_api';

const algaeResistanceIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739664/shingles/features/icons/algae_resistance.svg';
const algaeResistanceIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739584/shingles/features/icons/algae_resistance_hover.svg';
const coolcolorIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739362/shingles/features/icons/iconcoolcolor.svg';
const coolcolor20Icon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739295/shingles/features/icons/iconcoolcolor20.svg';
const coolcolorFlagIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739039/shingles/features/icons/flagcoolcolor.svg';
const coolcolor20FlagIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674738932/shingles/features/icons/flagiconcoolcolor20.svg';

const sbsIcon = 'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746407/shingles/features/icons/sbs.svg';
const sbsIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746323/shingles/features/icons/sbs_hover.svg';
const surenailIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746272/shingles/features/icons/surenail.svg';
const surenailIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746223/shingles/features/icons/surenail_hover.svg';
const trudefinitionIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746173/shingles/features/icons/trudefinition.svg';
const trudefinitionIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746129/shingles/features/icons/trudefinition_hover.svg';
const warranty25Icon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674746056/shingles/features/icons/warranty25.svg';
const warranty25IconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741520/shingles/features/icons/warranty25_hover.svg';
const warranty25Image =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741474/shingles/features/warranty_25_feature.png';
const warrantyLifetimeIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741425/shingles/features/icons/warranty_lifetime.svg';
const warrantyLifetimeIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741370/shingles/features/icons/warranty_lifetime_hover.svg';
const warrantyLifetimeImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741313/shingles/features/warranty_lifetime_feature.png';
const weatherguardIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741264/shingles/features/icons/weatherguard.svg';
const weatherguardIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674741202/shingles/features/icons/weatherguard_hover.svg';

const windResistanceHighestIcon =
  'https://imagecdn.owenscorning.com/image/upload/v1784809357/pagebuilder/uploads/prod/458bd69f-4690-435e-b821-da26451b0ace/160windresistance.svg';
const windResistanceHighestIconHover = windResistanceHighestIcon;
const windResistanceHighIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_svg,q_auto/v1678288703/shingles/wind_resistances/icons/high-wind.svg';
const windResistanceHighIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,co_rgb:d40f7d,e_colorize,dpr_2.0,w_20,h_20/v1678288703/shingles/wind_resistances/icons/high-wind.svg';
const windResistanceLowIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_svg,q_auto/v1678292659/shingles/wind_resistances/icons/low-wind.svg';
const windResistanceLowIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,co_rgb:d40f7d,e_colorize,dpr_2.0,w_20,h_20/v1678292659/shingles/wind_resistances/icons/low-wind.svg';
const windResistanceMediumIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_svg,q_auto/v1678288703/shingles/wind_resistances/icons/medium-wind.svg';
const windResistanceMediumIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,co_rgb:d40f7d,e_colorize,dpr_2.0,w_20,h_20/v1678288703/shingles/wind_resistances/icons/medium-wind.svg';
// Cloudinary images - USE THOSE IF POSSIBLE
const newColorIcon =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1611672982/roofing/shingles/icons/vibrant-dimensional-color.svg';
const newColorIconHover =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1611672977/roofing/shingles/icons/vibrant-dimensional-color-hover.svg';
const newColorModalImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,w_250,q_80/v1611773148/roofing/shingles/modals/premium-color-blends.jpg';
const newColorImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/f_auto,w_470,q_60/v1611773376/roofing/shingles/features/premium-color-blends.jpg';

const algaeResistanceImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674740128/shingles/features/algae_resistance.jpg';
const coolcolorImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674740067/shingles/features/coolcolor.png';
const coolcolor20Image =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739927/shingles/features/coolcolor_20.jpg';
const sbsImage = 'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739878/shingles/features/sbs.jpg';
const surenailImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739818/shingles/features/surenail.png';
const trudefinitionImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739770/shingles/features/trudefinition.jpg';
const weatherguardImage =
  'https://imagecdn.owenscorning.com/ocimages/image/upload/v1674739717/shingles/features/weatherguard.jpg';
const windResistanceImage =
  'https://imagecdn.owenscorning.com/image/upload/v1777658765/pagebuilder/uploads/prod/e660a46b-5a12-4536-8db1-52fd8aff0630/Wind%20Resistance.jpg';

export const FeaturesContext = createContext(null);

export const ENABLED_FEATURE_FLAGS = ['scoty', 'coolcolor', 'cool-20-plus', 'newcolor'];

const CATEGORY_ORDER = ['feature', 'warranty', 'wind_resistance', 'impact_resistance', 'energy'];

const calculateOrder = (category, positionInCategory) => {
  const categoryIndex = CATEGORY_ORDER.indexOf(category);
  const categoryBase = categoryIndex * 100;
  return categoryBase + positionInCategory;
};

const translate = (translations, key) => translations?.[key] || {};

class Feature {
  constructor(props) {
    Object.assign(this, {
      category: 'feature',
      analyticsName: featuresConfig.features.analytics.name,
      excludeFromFeaturesList: false,
      ...props,
    });

    if (props.translations) {
      Object.assign(this, props.translations);
    }

    // ShingleRow, BadgeItem and filtersConfig all read analyticsOption for data-track-destination,
    // but the locale files carry it as data_track_destination
    this.analyticsOption = this.analyticsOption || this.data_track_destination;
  }

  // eslint-disable-next-line class-methods-use-this
  itemAttributes() {
    return null;
  }

  isIncludedIn(shingle) {
    return shingle[this.key];
  }

  isInShingleOrColor(shingle) {
    return this.isIncludedIn(shingle) || (shingle.shingle_colors || []).some(sc => this.isIncludedIn(sc));
  }

  shouldShowFlag(shingle) {
    return this.isIncludedIn(shingle);
  }
}

class Warranty extends Feature {
  constructor(props) {
    super({ category: 'warranty', analyticsName: featuresConfig.warranties.analytics.name, ...props });
  }

  isIncludedIn(shingle) {
    return shingle.warranty === this.name;
  }
}

class WindResistance extends Feature {
  constructor(props) {
    super({ category: 'wind_resistance', analyticsName: featuresConfig.windResistances.analytics.name, ...props });
  }

  isIncludedIn(shingle) {
    return shingle.wind_resistance_uid === this.uid;
  }
}

class ShingleColorFeature extends Feature {
  shingleColorFeature = true;
}

class NewColorFeature extends ShingleColorFeature {
  // eslint-disable-next-line class-methods-use-this
  isIncludedIn() {
    return false;
  }

  shouldShowFlag(shingle) {
    return shingle[this.key];
  }
}

const featureDefinitions = [
  {
    key: 'weatherguard',
    icon: weatherguardIcon,
    iconHover: weatherguardIconHover,
    image: weatherguardImage,
  },
  {
    key: 'surenail',
    icon: surenailIcon,
    iconHover: surenailIconHover,
    image: surenailImage,
  },
  {
    key: 'trudefinition',
    icon: trudefinitionIcon,
    iconHover: trudefinitionIconHover,
    image: trudefinitionImage,
  },
  {
    key: 'algae_resistance',
    icon: algaeResistanceIcon,
    iconHover: algaeResistanceIconHover,
    image: algaeResistanceImage,
    showDetails: 'bottom',
  },
  {
    key: 'sbs',
    icon: sbsIcon,
    iconHover: sbsIconHover,
    image: sbsImage,
  },
];

const newColorDefinitions = [
  {
    key: 'newcolor',
    icon: newColorIcon,
    iconHover: newColorIconHover,
    image: newColorImage,
    modalImage: newColorModalImage,
    flagStyle: { height: 28, marginRight: 'auto', marginTop: 13 },
    showDetails: 'top',
  },
];

const premiumColorBlendDefinitions = [
  {
    key: 'premium_color_blend',
    icon: newColorIcon,
    iconHover: newColorIconHover,
    image: newColorImage,
    modalImage: newColorModalImage,
  },
];

const warrantyDefinitions = [
  {
    key: 'warranty25',
    icon: warranty25Icon,
    iconHover: warranty25IconHover,
    image: warranty25Image,
    url: '/roofing/warranty',
    extraUrl: 'https://www.owenscorning.com/roofing/warranty/#manage-warranty',
    showDetails: 'top',
  },
  {
    key: 'warrantyLifetime',
    icon: warrantyLifetimeIcon,
    iconHover: warrantyLifetimeIconHover,
    image: warrantyLifetimeImage,
    url: '/roofing/warranty',
    extraUrl: 'https://www.owenscorning.com/roofing/warranty/#manage-warranty',
    showDetails: 'top',
  },
];

const windResistanceDefinitions = [
  {
    key: 'wind_resistance_highest',
    translationKey: 'highest',
    icon: windResistanceHighestIcon,
    iconHover: windResistanceHighestIconHover,
    image: windResistanceImage,
    url: '/roofing/warranty',
    showDetails: 'top',
    uid: '160mph',
    value: 'Up to 160 MPH | 257 KMH',
  },
  {
    key: 'wind_resistance_high',
    translationKey: 'high',
    icon: windResistanceHighIcon,
    iconHover: windResistanceHighIconHover,
    image: windResistanceImage,
    url: '/roofing/warranty',
    showDetails: 'top',
    uid: '130mph',
    value: '130 MPH | 209 KMH',
  },
  {
    key: 'wind_resistance_medium',
    translationKey: 'medium',
    icon: windResistanceMediumIcon,
    iconHover: windResistanceMediumIconHover,
    image: windResistanceImage,
    url: '/roofing/warranty',
    showDetails: 'top',
    uid: '110/130mph',
    value: '110/130 MPH | 177/209 KMH',
  },
  {
    key: 'wind_resistance_low',
    translationKey: 'low',
    icon: windResistanceLowIcon,
    iconHover: windResistanceLowIconHover,
    image: windResistanceImage,
    url: '/roofing/warranty',
    showDetails: 'top',
    uid: '60mph',
    value: '60 MPH | 97 KMH',
  },
];

class ImpactResistance extends Feature {
  constructor(props) {
    super({ category: 'impact_resistance', analyticsName: featuresConfig.impactResistances.analytics.name, ...props });
  }

  isIncludedIn(shingle) {
    return shingle.impact_resistance_uid === this.value;
  }
}

const impactResistanceDefinitions = [
  { key: 'class-3', value: 'class-3' },
  { key: 'class-4', value: 'class-4' },
  { key: 'class-5', value: 'class-5' },
];

// Add SCOTY features
class Scoty extends Feature {
  constructor(props) {
    super({
      category: '',
      excludeFromFeaturesList: true,
      ...props,
    });
  }

  itemAttributes(color) {
    const lookup = this.scotys[color.scoty_uid];
    if (!lookup) {
      return null;
    }
    const { image: { file, alt } = {} } = lookup;

    const [root, path] = file?.split('/image/upload/') || [];
    const [cloudname] = root?.split('/').reverse() || [];

    const cloudinary = cloudname
      ? new Cloudinary({
          cloud_name: cloudname,
          secure: true,
        })
      : null;

    return {
      flagIcon: cloudinary?.url(path, {
        transformation: [
          {
            crop: 'scale',
            width: 209,
            height: 209,
            quality: 'auto',
            fetchFormat: 'auto',
          },
        ],
        type: 'upload',
      }),
      flagAlt: alt,
    };
  }

  isIncludedIn(color) {
    return !!this.scotys[color.scoty_uid];
  }
}

const energyDefinitions = [
  {
    key: 'coolcolor',
    icon: coolcolorIcon,
    iconHover: coolcolorIcon,
    flagIcon: coolcolorFlagIcon,
    image: coolcolorImage,
    minSRI: 16,
  },
  {
    key: 'cool-20-plus',
    icon: coolcolor20Icon,
    iconHover: coolcolor20Icon,
    flagIcon: coolcolor20FlagIcon,
    image: coolcolor20Image,
    minSRI: 20,
  },
];

class EnergyFeatures extends Feature {
  tiers = ['coolcolor', 'cool-20-plus'];

  shingleColorFeature = true;

  constructor(props) {
    super({ category: 'feature', ...props });
    this.allFeatures = props.allFeatures || [];
    this.isIncludedIn = this.isIncludedIn.bind(this);
  }

  inSRIRange(obj) {
    const sri = parseInt(obj.sri, 10) || -1;
    return sri >= this.minSRI;
  }

  shouldShowFlag(obj) {
    const currentLevel = this.tiers.indexOf(this.key);
    const higherLevels = this.tiers.slice(currentLevel + 1);
    const blockedByHigherLevel = higherLevels.some(level => {
      const feature = this.allFeatures.find(f => f.key === level);
      return feature?.isIncludedIn(obj);
    });

    if (blockedByHigherLevel) return false;
    return obj[this.key] || this.inSRIRange(obj);
  }

  isIncludedIn(obj) {
    return obj[this.key] || this.inSRIRange(obj);
  }
}

const buildFeatures = translations => {
  const features = [
    ...featureDefinitions.map(
      (obj, index) =>
        new Feature({
          ...obj,
          order: calculateOrder('feature', index),
          translations: translate(translations, obj.key),
        })
    ),
    ...newColorDefinitions.map(
      (obj, index) =>
        new NewColorFeature({
          ...obj,
          order: calculateOrder('feature', 5 + index),
          translations: translate(translations, obj.key),
        })
    ),
    ...premiumColorBlendDefinitions.map(
      (obj, index) =>
        new ShingleColorFeature({
          ...obj,
          order: calculateOrder('feature', 6 + index),
          translations: translate(translations, obj.key),
        })
    ),
    new Scoty({
      key: 'scoty',
      order: calculateOrder('feature', 2),
      translations: translate(translations, 'scoty'),
    }),
  ];

  features.push(
    ...warrantyDefinitions.map(
      (obj, index) =>
        new Warranty({
          ...obj,
          order: calculateOrder('warranty', index),
          translations: translate(translations, obj.key),
        })
    )
  );

  features.push(
    ...windResistanceDefinitions.map(
      (obj, index) =>
        new WindResistance({
          ...obj,
          order: calculateOrder('wind_resistance', index),
          translations: translate(translations?.wind_resistance, obj.translationKey),
        })
    )
  );

  features.push(
    ...impactResistanceDefinitions.map(
      (obj, index) =>
        new ImpactResistance({
          ...obj,
          order: calculateOrder('impact_resistance', index),
        })
    )
  );

  features.push(
    ...energyDefinitions.map(
      (obj, index) =>
        new EnergyFeatures({
          ...obj,
          order: calculateOrder('energy', index),
          translations: translate(translations, obj.key),
          allFeatures: features,
        })
    )
  );

  return features;
};

const getScotyData = _.memoize(code =>
  // eslint-disable-next-line camelcase
  cms_api.get_single_contents({
    filter: {
      type: 'Cms::Content::Attribute',
      language_iso_code: code,
      route: '/roofing',
      name: 'Shingle Color of the Year (SCOTY) Badges',
    },
    fields: {
      '*': 'contents',
    },
  })
);

const getImpactResistanceData = _.memoize(code =>
  // eslint-disable-next-line camelcase
  cms_api.get_single_contents({
    filter: {
      type: 'Cms::Content::Attribute',
      language_iso_code: code,
      route: '/roofing',
      name: 'Impact Resistance',
    },
    fields: {
      '*': 'contents',
    },
  })
);

export const enrichFeatures = (features, scotyAttribute, impactResistantAttribute) => {
  const scotyFeature = features.find(f => f.key === 'scoty');
  if (scotyFeature && scotyAttribute?.items?.length > 0) {
    scotyFeature.scotys = _.keyBy(scotyAttribute.items, i => i.value);
  } else {
    _.remove(features, f => f.key === 'scoty');
  }

  let enriched = features;
  if (impactResistantAttribute?.items?.length > 0) {
    const lookups = _.keyBy(impactResistantAttribute.items, i => i.value);
    enriched = features.map(feature => {
      if (feature.category !== 'impact_resistance') return feature;

      const item = lookups[feature.key];
      if (!item) return feature;

      return Object.assign(feature, {
        singular: impactResistantAttribute.singular,
        icon: item.icon.file,
        iconHover: item.icon.file,
        alt: item.icon.alt,
        name: item.label,
        title: item.details?.title,
        reusable: item.details?.reusable,
        description: item.details?.reusable ? 'dummy to make the icon on row work' : feature.description,
      });
    });
  }

  return sortBy(enriched, 'order');
};

export const asyncFeatureFactory = async localeCode => {
  const featureTranslations = getFeatureTranslations(localeCode);
  const features = buildFeatures(featureTranslations);
  const [scotyAttribute, impactResistantAttribute] = await Promise.all([
    getScotyData(localeCode),
    getImpactResistanceData(localeCode),
  ]);
  return enrichFeatures(features, scotyAttribute, impactResistantAttribute);
};

export default asyncFeatureFactory;

export const useFeatures = ({ prefetchedScoty, prefetchedImpactResistance } = {}) => {
  const localeCode = useLocaleCode();
  const hasPrefetchedData = prefetchedScoty !== undefined || prefetchedImpactResistance !== undefined;

  const [allRoofingFeatures, setAllRoofingFeatures] = useState(() => {
    if (!hasPrefetchedData) return undefined;
    return enrichFeatures(
      buildFeatures(getFeatureTranslations(localeCode)),
      prefetchedScoty,
      prefetchedImpactResistance
    );
  });

  useEffect(() => {
    if (prefetchedScoty !== undefined) {
      getScotyData.cache.set(localeCode, Promise.resolve(prefetchedScoty));
    }
    if (prefetchedImpactResistance !== undefined) {
      getImpactResistanceData.cache.set(localeCode, Promise.resolve(prefetchedImpactResistance));
    }

    // Data already populated from prefetch — seeding the cache is enough
    if (hasPrefetchedData) return undefined;

    let mounted = true;
    if (localeCode) {
      asyncFeatureFactory(localeCode).then(features => {
        if (mounted) setAllRoofingFeatures(features);
      });
    }
    return () => {
      mounted = false;
    };
  }, [localeCode, hasPrefetchedData, prefetchedScoty, prefetchedImpactResistance]);

  return allRoofingFeatures;
};

export const useFeaturesWithContext = () => {
  const contextFeatures = useContext(FeaturesContext);
  const asyncFeatures = useFeatures();
  return contextFeatures ?? asyncFeatures;
};
